import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../components/user/user.service';
import { environment, messagelanguage } from 'src/environments/environment';

@Component({
  selector: 'app-validatesmsentry',
  templateUrl: './validatesmsentry.component.html',
  styleUrls: ['./validatesmsentry.component.scss']
})
export class ValidatesmsentryComponent implements OnInit, AfterViewInit {
  @Input() obj_email:string = ''
  @Input() obj_source:string = 'login'
  @Input() obj_loginInfo: {username: string, password: string}
  @Input() obj_canUpdatePhoneNumber: boolean = false
  @Input() obj_showProgressBar: boolean = false

  @Output() obj_updatedPhoneNumber = new EventEmitter<string>();
  @Output() obj_updatedNormalizedPhoneNumber = new EventEmitter<string>();
  @Output() obj_confirmSm = new EventEmitter<any>();
  @Output() obj_goBack = new EventEmitter<boolean>();

  @ViewChild('num1') obj_num1: ElementRef;
  @ViewChild('num2') obj_num2: ElementRef;
  @ViewChild('num3') obj_num3: ElementRef;
  @ViewChild('num4') obj_num4: ElementRef;
  @ViewChild('num5') obj_num5: ElementRef;
  @ViewChild('num6') obj_num6: ElementRef;

  vc_phonenumber: string='';
  vc_normalizedPhonenumber: string = '';
  vc_isloading: boolean=false;
  vc_showPhoneUpdate: boolean = false;
  vc_resendCooldown: number = 0;
  private cooldownInterval: any;

  obj_phoneToUpdate = {
    username: '',
    password: '',
    newPhone: '',
    normalizedPhone: ''
  }

  constructor(
    private oc_userService: UserService,
    public oc_router: Router,
    public oc_toastr: ToastrService) { }

  ngOnInit(): void {
    console.log(localStorage.getItem("statusPhone"));
    if (localStorage.getItem("statusPhone") == "false") {
      this.obj_source = 'Verifed';
    }
  }

  ngAfterViewInit() {
    this.vc_isloading = false;
    if (!this.vc_showPhoneUpdate) {
      this.obj_num1.nativeElement.focus();
    }
  }

  fn_exit(){
    this.obj_goBack.emit(true);
  }

  fn_updatedPhonenumber(value:string) {
    this.vc_phonenumber = value;
  }

  fn_updatedNormalizedPhonenumber(value:string) {
    this.vc_normalizedPhonenumber = value;
  }

  fn_confirmButton() {
    if (this.vc_showPhoneUpdate) {
      if (!this.oc_userService.isLoggedIn && this.obj_loginInfo)
      {
        this.fn_sendSmsToNewPhoneUnauthenticated();
      } else {
        this.fn_sendSmsToNewPhoneAuthenticated();
      }
    }
    else {
      if (!this.oc_userService.isLoggedIn && this.obj_loginInfo)
      {
        this.fn_confirmSmsUnauthenticated();
      } else {
        this.fn_confirmSmsAuthenticated();
      }
    }
  }

  async fn_resendCode() {
    if (this.vc_resendCooldown > 0) return;

    if (!this.oc_userService.isLoggedIn && this.obj_loginInfo) {
      (await this.oc_userService.resendSms(this.obj_loginInfo))
      .subscribe((response: any) => {
        this.oc_toastr.success(messagelanguage.message.Sms_Sent);
        this.fn_startResendCooldown();
        this.fn_clearCodeInputs();
      }, (error) => {
        this.fn_handleSmsError(error);
      });
    } else {
      (await this.oc_userService.resendSmsAuth())
      .subscribe((response: any) => {
        this.oc_toastr.success(messagelanguage.message.Sms_Sent);
        this.fn_startResendCooldown();
        this.fn_clearCodeInputs();
      }, (error) => {
        this.fn_handleSmsError(error);
      });
    }
  }

  private fn_startResendCooldown() {
    this.vc_resendCooldown = 60;
    this.cooldownInterval = setInterval(() => {
      this.vc_resendCooldown--;
      if (this.vc_resendCooldown <= 0) {
        clearInterval(this.cooldownInterval);
      }
    }, 1000);
  }

  private fn_clearCodeInputs() {
    if (this.obj_num1) this.obj_num1.nativeElement.value = '';
    if (this.obj_num2) this.obj_num2.nativeElement.value = '';
    if (this.obj_num3) this.obj_num3.nativeElement.value = '';
    if (this.obj_num4) this.obj_num4.nativeElement.value = '';
    if (this.obj_num5) this.obj_num5.nativeElement.value = '';
    if (this.obj_num6) this.obj_num6.nativeElement.value = '';
    if (this.obj_num1) this.obj_num1.nativeElement.focus();
  }

  async fn_sendSmsToNewPhoneAuthenticated() {
    this.obj_phoneToUpdate.newPhone = this.vc_phonenumber;
    this.obj_phoneToUpdate.normalizedPhone = this.vc_normalizedPhonenumber;

    (await this.oc_userService.sendSmsToNewPhoneAuthenticated(this.obj_phoneToUpdate))
    .subscribe((response:any)=> {
      this.vc_showPhoneUpdate = false;
      this.oc_toastr.success(messagelanguage.message.Sms_Sent);
    }, (error) => {
      this.fn_handleSmsError(error);
    })
  }

  fn_showPhoneUpdate(event: Event) {
    event.preventDefault();
    this.vc_showPhoneUpdate = true;
  }

  async fn_sendSmsToNewPhoneUnauthenticated() {
    this.obj_phoneToUpdate.username = this.obj_loginInfo.username;
    this.obj_phoneToUpdate.password = this.obj_loginInfo.password;
    this.obj_phoneToUpdate.newPhone = this.vc_phonenumber;
    this.obj_phoneToUpdate.normalizedPhone = this.vc_normalizedPhonenumber;

    (await this.oc_userService.sendSmsToNewPhone(this.obj_phoneToUpdate))
    .subscribe((response:any)=> {
      this.vc_showPhoneUpdate = false;
      this.oc_toastr.success(messagelanguage.message.Sms_Sent);
    }, (error) => {
      this.fn_handleSmsError(error);
    })
  }

  async fn_confirmSmsAuthenticated() {
    const code: string = this.obj_num1.nativeElement.value + this.obj_num2.nativeElement.value +
    this.obj_num3.nativeElement.value + this.obj_num4.nativeElement.value +
    this.obj_num5.nativeElement.value + this.obj_num6.nativeElement.value;

    if (!code || code.length < 6) {
      this.oc_toastr.warning(messagelanguage.message.Code_Required);
      return;
    }

    (await this.oc_userService.confirmPhone(code))
    .subscribe(
      (response:any) => {
        this.obj_confirmSm.emit(response.body.message);
        this.oc_toastr.success(messagelanguage.message.Valid_code);
      }, (error) => {
        this.fn_handleValidationError(error);
      });
  };


  async fn_confirmSmsUnauthenticated() {
    if (this.obj_loginInfo.password == undefined) {
      this.obj_loginInfo.password = '.'
    }
    const code: string = this.obj_num1.nativeElement.value + this.obj_num2.nativeElement.value +
    this.obj_num3.nativeElement.value + this.obj_num4.nativeElement.value +
    this.obj_num5.nativeElement.value + this.obj_num6.nativeElement.value;

    if (!code || code.length < 6) {
      this.oc_toastr.warning(messagelanguage.message.Code_Required);
      return;
    }

    (await this.oc_userService.validateSms(this.obj_loginInfo, code))
      .subscribe(
        (response:any) => {
          if (response.status == 200) {
            console.log(response.body)
            this.obj_confirmSm.emit(response.body.user);
            this.oc_toastr.success(messagelanguage.message.Valid_code);
          }
        }, (error) => {
          this.fn_handleValidationError(error);
        });
      };

  private fn_handleValidationError(error: any) {
    const message = error?.error?.message;
    const status = error?.status;

    if (status === 400) {
      if (message === 'Code_Required') {
        this.oc_toastr.warning(messagelanguage.message.Code_Required);
      } else {
        this.oc_toastr.error(message || messagelanguage.message.Bad_request);
      }
    } else if (status === 401) {
      if (message === 'Code_Expired') {
        this.oc_toastr.warning(messagelanguage.message.Code_Expired);
      } else if (message === 'Incorrect_code') {
        this.oc_toastr.error(messagelanguage.message.Incorrect_code);
      } else if (message === 'Invalid_Credentials') {
        this.oc_toastr.error(messagelanguage.message.Invalid_email_or_password);
      } else {
        this.oc_toastr.error(messagelanguage.message.Incorrect_code);
      }
    } else if (status === 429) {
      if (message === 'Too_Many_Attempts') {
        this.oc_toastr.error(messagelanguage.message.Too_Many_Attempts);
      } else {
        this.oc_toastr.warning(messagelanguage.message.Sms_Cooldown);
      }
    } else {
      this.oc_toastr.error(messagelanguage.message.No_control_error);
    }
    console.error(error);
  }

  private fn_handleSmsError(error: any) {
    const message = error?.error?.message;
    const status = error?.status;

    if (status === 429) {
      this.oc_toastr.warning(messagelanguage.message.Sms_Cooldown);
      this.fn_startResendCooldown();
    } else if (status === 401) {
      this.oc_toastr.error(messagelanguage.message.Invalid_email_or_password);
    } else if (status === 400 && message === 'Invalid_PhoneNumber') {
      this.oc_toastr.error(messagelanguage.message.Invalid_PhoneNumber);
    } else {
      this.oc_toastr.error(message || messagelanguage.message.No_control_error);
    }
    console.error(error);
  }
}
